import o from "clsx";
import e from "react";
import { s as r } from "../../../../../RideFullIcon.module-B-94u-qz.mjs";
function p({
  size: t = "small",
  accessibilityTitle: C = "full icon error light",
  className: l,
  "data-testid": n
}) {
  const a = () => o(l, r["ride-full-icon"], {
    [r[`size-${t}`]]: t
  });
  return /* @__PURE__ */ e.createElement("div", { className: a(), "data-testid": n }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "72",
      height: "72",
      viewBox: "0 0 72 72",
      fill: "none",
      stroke: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    C && /* @__PURE__ */ e.createElement("title", null, C),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M42.3366 27H24.016L24.3957 24.75H42.7163L42.3366 27ZM41.5913 31.5H23.2707L22.891 33.75H41.2116L41.5913 31.5ZM36.495 60.8006L39.3413 43.875H21.0207L17.2069 66.5606C17.1629 66.8234 17.0272 67.062 16.8237 67.2341C16.6203 67.4061 16.3624 67.5003 16.096 67.5H8.28565C8.12209 67.5002 7.96046 67.4647 7.81201 67.3961C7.66356 67.3274 7.53187 67.2272 7.42612 67.1024C7.32036 66.9777 7.24308 66.8314 7.19966 66.6737C7.15624 66.516 7.14773 66.3507 7.17472 66.1894L16.9144 8.25189C17.0913 7.2028 17.6341 6.25031 18.4466 5.56346C19.2591 4.87661 20.2886 4.49984 21.3525 4.50002H50.445C51.0991 4.49998 51.7453 4.64251 52.3386 4.91768C52.9319 5.19286 53.4581 5.59406 53.8806 6.09336C54.3031 6.59266 54.6116 7.17804 54.7848 7.80875C54.9579 8.43946 54.9915 9.10032 54.8832 9.74533L50.0935 38.25C50.6616 37.8706 51.3015 37.6117 51.9736 37.4894C52.6457 37.3671 53.3358 37.384 54.0011 37.539C54.6665 37.694 55.2929 37.9838 55.8418 38.3905C56.3907 38.7973 56.8503 39.3123 57.1922 39.9038L64.9435 53.3391L57.3047 7.87502C57.042 6.30043 56.2284 4.8704 55.009 3.8401C53.7896 2.8098 52.2439 2.24626 50.6475 2.25002H21.3525C19.7562 2.24626 18.2104 2.8098 16.9911 3.8401C15.7717 4.8704 14.9581 6.30043 14.6953 7.87502L4.95565 65.8125C4.87382 66.2966 4.89861 66.7928 5.02828 67.2664C5.15796 67.7399 5.3894 68.1795 5.70646 68.5544C6.02353 68.9293 6.41856 69.2305 6.86403 69.437C7.30949 69.6435 7.79465 69.7503 8.28565 69.75H16.096C16.8939 69.7505 17.6663 69.4683 18.2759 68.9534C18.8855 68.4385 19.293 67.7243 19.426 66.9375L22.9247 46.125H30.5185L33.7978 65.6438C33.9009 65.3566 34.0289 65.079 34.1803 64.8141L36.495 60.8006Z",
        fill: "url(#paint0_linear_2718_1076)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M69.4125 66.0599L55.035 41.1383C54.816 40.7593 54.5011 40.4446 54.1219 40.2258C53.7428 40.007 53.3127 39.8918 52.875 39.8918C52.4372 39.8918 52.0072 40.007 51.628 40.2258C51.2489 40.4446 50.934 40.7593 50.715 41.1383L36.3375 66.0599C36.1187 66.4388 36.0035 66.8687 36.0036 67.3063C36.0037 67.7439 36.119 68.1737 36.338 68.5526C36.5569 68.9315 36.8718 69.246 37.2509 69.4646C37.6299 69.6831 38.0599 69.798 38.4975 69.7977H67.2525C67.6901 69.798 68.12 69.6831 68.4991 69.4646C68.8782 69.246 69.193 68.9315 69.412 68.5526C69.6309 68.1737 69.7462 67.7439 69.7463 67.3063C69.7464 66.8687 69.6313 66.4388 69.4125 66.0599ZM54.5062 48.3917L54.2025 60.2042H51.584L51.255 48.3917H54.5062ZM54.3937 65.7646C54.0397 66.1461 53.5635 66.3919 53.0474 66.4596C52.5314 66.5274 52.0079 66.4127 51.5674 66.1355C51.1269 65.8582 50.7971 65.4359 50.6349 64.9413C50.4727 64.4467 50.4884 63.911 50.6792 63.4268C50.87 62.9426 51.224 62.5402 51.68 62.2892C52.1359 62.0382 52.6652 61.9544 53.1764 62.0522C53.6876 62.1499 54.1486 62.4232 54.4798 62.8248C54.8109 63.2263 54.9914 63.731 54.99 64.2514C54.9978 64.5313 54.9485 64.8099 54.845 65.07C54.7415 65.3302 54.586 65.5665 54.3881 65.7646H54.3937ZM39.9769 12.0121C40.1203 10.6508 39.2597 8.93237 36.18 8.93237H30.2315L27.509 20.1824H30.6028L31.5928 16.0311H33.3112L35.9634 20.188H39.4031L36.3093 15.6008C38.9728 14.6642 39.7603 13.5196 39.9769 12.0121ZM36.5372 12.2286C36.3937 13.5196 35.5331 13.8036 34.0284 13.8036H31.7362L32.6672 10.6508H34.9593C36.2503 10.6508 36.6806 11.368 36.5372 12.2286Z",
        fill: "url(#paint1_linear_2718_1076)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear_2718_1076",
        x1: "4.90845",
        y1: "2.25",
        x2: "43.8948",
        y2: "80.2682",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { offset: "0.272135", stopColor: "#34263B" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "0.658079", stopColor: "#13172C" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear_2718_1076",
        x1: "61.4031",
        y1: "72.052",
        x2: "11.0374",
        y2: "40.8351",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#F93757" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#FB8296" })
    ))
  ));
}
export {
  p as RideFiErrorLight
};
